import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Checkbox, ListItemButton, ListItemIcon, ListItemText, ListSubheader, } from '@mui/material';
import { FixedSizeList } from 'react-window';
import memoizeOne from 'memoize-one';
const getListSize = memoizeOne(() => {
    const height = window.innerHeight;
    if (height > 900)
        return 560;
    else if (height > 700)
        return 360;
    else
        return 300;
});
const DeviceListItem = memo(function DeviceListItem(props) {
    const { index, onChangeIndex, name, checked } = props;
    return (_jsxs(ListItemButton, { onClick: (event) => onChangeIndex(event, index), disableGutters: true, children: [_jsx(ListItemIcon, { children: _jsx(Checkbox, { checked: checked, tabIndex: -1, disableRipple: true }) }), _jsx(ListItemText, { primary: name, sx: {
                    maxHeight: '25px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                } })] }));
});
export const DeviceList = memo(function DeviceList(props) {
    const { selected_device_ids, handleToggle, devices_len, devices } = props;
    function renderRow(props) {
        const { data, index, style } = props;
        const dev = data[index];
        return (_jsx("div", { style: style, children: _jsx(DeviceListItem, { index: dev.id, onChangeIndex: handleToggle(dev.id), name: dev.name, checked: selected_device_ids.indexOf(dev.id) !== -1 }, dev.id) }));
    }
    return (_jsx(ErrorBoundary, { children: devices_len !== 0 ? (_jsx(FixedSizeList, { style: {
                overflow: 'auto',
            }, height: getListSize(), width: "100%", itemCount: devices_len, itemSize: 50, itemData: devices, children: renderRow })) : (_jsx(ListSubheader, { disableGutters: true, children: "\u041D\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0422\u0421" })) }));
});
